export const SIDEPANEL_WIDTH = '270px'

export const resourceIsCurrent = (resource) => (
  resource.status != 'pending_completing' &&
  resource.status != 'overdue' &&
  resource.status != 'upcoming' &&
  resource.status != 'completed'
)

export const selectedUrl = (props, sender_url, sender_name) => {
  if (sender_url && sender_name) {
    if (props.id)
      return `/organizations/${props.organization.name}/drug_test_requests/${props.id}?sender=${sender_url}&sender_name=${sender_name}`;
    else
      return `/organizations/${props.organization.name}/drug_test_request_schedules/${props.schedule_id}`;
  }
  else{
    if (props.id)
      return `/organizations/${props.organization.name}/drug_test_requests/${props.id}`;
    else
      return `/organizations/${props.organization.name}/drug_test_request_schedules/${props.schedule_id}`;
  }
}
